export type LanguageCode = 'en' | 'nl' | 'fr';

type Language = {
	code: LanguageCode;
	file: `${LanguageCode}.ts`;
};

const languages: Language[] = [
	{
		code: 'en',
		file: 'en.ts',
	},
	{
		code: 'nl',
		file: 'nl.ts',
	},
	{
		code: 'fr',
		file: 'fr.ts',
	},
];

export default languages;
